import React, { useEffect, useRef, useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from '../../../../../../../../Setup/Shared/ModalHeader';
import { enumUtil } from '../../../../../../../../../utils/Enum';
import { useSelector } from 'react-redux';
import NotificationHandler from '../../../../../../../../../utils/NotificationHandler';
// import { ServerRequestProtected, ServerRequestPublic } from '../../../../../../../../utils/ServerDataRequest';
import FormValidator from '../../../../../../../../../utils/FormValidator';
import { format } from 'date-fns';
import Loader from '../../../../../../../../shared/Loader/Loader';
import DropdownValueHandler from '../../../../../../../../shared/SuperSearch/DropdownValueHandler';
import SuperSearchList from '../../../../../../../../shared/SuperSearch/SuperSearchList';
import isNull from '../../../../../../../../../utils/NullChecking';

const AddNewRiskAssessment = ({  ...props }) => {
    const { isOpenRiskAssessment, onClose, riskAssessmentModal,  setRiskAssessmentModal, RiskAssessmentID, setIsClose, onCancel, dropDownData } = props;
  console.log("mainPassedModal", riskAssessmentModal)
    // let IsEditAllowed = FindFirstChild('Patient','RA')?.IsAdd
    // let IsDeleteAllowed = FindFirstChild('Patient','RA')?.IsDeleted

    // const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const API_URL = enumUtil.controller.PATIENT
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    // const API_URL_Wasabi = enumUtil.controller.Wasabi;
    // let {  } = { ...props }
    const [isLoading, setIsLoading] = useState(false)

    // const [modalActive, setModalActive] = useState(false)
    // const [pdfFile, setPdfFile] = useState(null);
    // const [txtFile, setTxtFile] = useState(null);
    // const [imgFile, setImgFile] = useState(null);

    // const fileInputRef = useRef(null);
    let RA_Modal = {
        // PatientID: PateintIDR + "",
        RiskAssessmentID: '',
        "AreaOfRisk": "",
        "RiskLevel": "",
        "RiskFactors": "",
        "ProtectiveFactors": "",
        "RiskAssessmentNotes": "",
        "UpdatedBy": '',
        "UpdateDate": ''
        // ...riskAssessmentModal,
        // File: '',
        // ReferedBy: '',
        // RADateType: format(new Date(), 'MM/dd/yyy'),
        // RAType: '',
        // Provider: '',
        // Source: '',
    }
    let valModal = {}
    let ValidationModal = {
      AreaOfRiskVal: '',
    }
    const [RAValidationModal, setRAValidationModal] = useState(ValidationModal)
    const [RASaveUpdateModal, setRASaveUpdateModal] = useState({})
    const [mainRAModal, setMainRAModal] = useState(RA_Modal);
    const [raID, setRAID] = useState('');
    const [is, setIs] = useState(false);
    // const [file, setfile] = useState('')

    const handleRAChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        // if (process.env.REACT_APP_ISUPPERCASE === "true") {
        //     value = value.toUpperCase()
        // }
        let modal = { ...mainRAModal };
        let saveModal = { ...RASaveUpdateModal }
        modal[name] = value
        setMainRAModal(modal)
        for (var property in RA_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setRASaveUpdateModal(saveModal)
    }
    const RAValidation = async () => {
        let ValidationModal = {
            AreaOfRiskVal: FormValidator(
                mainRAModal.AreaOfRisk,
                enumUtil.enumValidationType.Required,
                'Area Of Risk',
            ),
        }
        await setRAValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    const addNewRA = () => {
        setRAID('0');
        setMainRAModal(RA_Modal);
        setRASaveUpdateModal({});
        setRiskAssessmentModal({ RiskAssessmentID: null });
        // removeFile();
        // setfile(null)
        //   props.setRAID(null);
        //   handleCancelRA();
        //   setRAID(null)
        //   handleClear();
    }

    // const handleClear = () => {
    //     setMainGoalsModal(Goals_Modal);
    //     setGoalsSaveUpdateModal({});
    // }

    const handleSaveRA = async (type) => {
        await RAValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // let data = { ...RASaveUpdateModal };
            // const formData = new FormData();
            // formData.append('TableName', enumUtil.enumAPITableName.PatientRA);
            // formData.append('ID', raID);
            // formData.append('data[PatientID]', PateintIDR + "");
            // if (!isNull(file)) {
            //     formData.append('File', file);
            // }
            // for (var key in data) {
            //     formData.append(`data[${key}]`, data[key]);
            // }
            ////////////////
            if (props?.isOpenedFrom === 'SOAP') {

                // console.log("setAssessmentData", riskAssessmentModal, mainRAModal);
                // mainRAModal.map(doc => 
                //     doc.RiskAssessmentID
                // )
                let { localFile, TableName, UpdatedBy, UpdateDate, ...localDoc} = riskAssessmentModal;
                let saveData = {
                    ...localDoc,
                    ...RASaveUpdateModal,
                    recordNoClient: props?.riskAssessmentModal?.recordNoClient,
                    'RiskAssessmentID': raID,
                    'PatientID': PateintIDR + "",
                    // ...(file ? { 'RAPath': file } : { riskAssessmentModal?.RAPath}),
                };
                console.log("setAssessmentDatasaveData", saveData);
                // Ensure recordNoClient is set on unsaved ras, reuse if editing existing unsaved doc
                const isNew = isNull(raID) || raID === "";

                if (isNew) {
                    // If editing an existing unsaved doc, keep its recordNoClient
                    if (!saveData.recordNoClient) {
                        // If creating a new unsaved doc (no recordNoClient yet), generate once
                        saveData.recordNoClient = String(Date.now());
                    }
                } else {
                    // For saved docs, remove recordNoClient before sending to backend
                    delete saveData.recordNoClient;
                }

                // Now use the saveData with consistent recordNoClient
                props?.setAssessmentData(prev => {
                    const encounterList = [...(prev.RiskAssessment || [])];

                    const mainViewObj = {
                        recordNoClient: saveData.recordNoClient || "",
                        ...riskAssessmentModal,
                        ...saveData,
                        RiskAssessmentID: raID ?? "",
                        ...(RASaveUpdateModal.RiskAssessmentID
                            ? { RiskAssessmentID: RASaveUpdateModal.RiskAssessmentID }
                            : {}),
                    };
                    console.log("setAssessmentDatasaveDatamainViewObj", encounterList, mainViewObj);

                    let updatedList;

                    if (isNew) {
                        const exists = encounterList.some(d => d.recordNoClient === mainViewObj.recordNoClient);
                        updatedList = exists
                            ? encounterList.map(d =>
                                d.recordNoClient === mainViewObj.recordNoClient ? mainViewObj : d
                            )
                            : [...encounterList, mainViewObj];
                    } else {
                        updatedList = encounterList.map(d =>
                            d.RiskAssessmentID === raID ? mainViewObj : d
                        );
                    }

                    console.log("setAssessmentDatasaveDatamainViewObjupdatedList", updatedList, raID);
                    return {
                        ...prev,
                        RiskAssessment: updatedList,
                    };
                });

                props?.setSaveRAData(prev => {
                    let cleanSaveData = { ...saveData };

                    if (isNew) {
                        // Check if this unsaved doc already has a recordNoClient
                        if (!cleanSaveData.recordNoClient) {
                            // New unsaved doc, assign new recordNoClient
                            cleanSaveData.recordNoClient = String(Date.now());
                        }
                        // No backend ID yet
                        cleanSaveData.RiskAssessmentID = "";
                    } else {
                        // Saved docs: remove recordNoClient before sending to backend
                        delete cleanSaveData.recordNoClient;
                        cleanSaveData.RiskAssessmentID = raID ?? "";
                    }

                    if (isNew) {
                        // Find existing unsaved doc by recordNoClient and update it
                        const existingIndex = prev.findIndex(
                            item => item.recordNoClient === cleanSaveData.recordNoClient
                        );

                        if (existingIndex !== -1) {
                            // Update existing unsaved doc
                            return prev.map((item, i) => (i === existingIndex ? { ...item, ...cleanSaveData } : item));
                        }

                        // Append new unsaved doc
                        return [...prev, cleanSaveData];
                    } else {
                        // Saved docs: update by RiskAssessmentID or add if missing
                        const idExist = prev.some(doc => doc.RiskAssessmentID === cleanSaveData.RiskAssessmentID);

                        return idExist
                            ? prev.map(doc =>
                                doc.RiskAssessmentID === cleanSaveData.RiskAssessmentID ? cleanSaveData : doc
                            )
                            : [...prev, cleanSaveData];
                    }
                });


                console.log("isOpenedFromRAsformData", props?.isOpenedFrom, saveData, mainRAModal)
                if (type === "Add Another") {
                    addNewRA();
                } else {
                    onClose();
                }
            }
        }
    }
    // const ViewFile = () => {
    //     let file = riskAssessmentModal?.localFile;
    //     if (!file) return;

    //     const type = file.type;
    //     // You can also use file.name to determine extension if needed

    //     if (type.includes("text")) {
    //         // 🔸 Text File (e.g. .txt)
    //         const reader = new FileReader();
    //         reader.onload = () => setTxtFile(reader.result);
    //         reader.readAsText(file);
    //     } else if (type.includes("image")) {
    //         // 🔸 Image File (e.g. .png, .jpg, .tiff)
    //         const objectURL = URL.createObjectURL(file);
    //         setImgFile(objectURL);
    //     } else if (type.includes("pdf")) {
    //         // 🔸 PDF File
    //         const objectURL = URL.createObjectURL(file);
    //         setPdfFile(objectURL);
    //     } else {
    //         // 🔸 Other Files (optional fallback)
    //         console.warn("Unsupported file type:", type);
    //     }

    //         setModalActive(true);
    //     // Store file for upload later
    //     // setLocalFile(file);
    //     };
    // const savefile = (e) => {
    //     setRiskAssessmentModal(prev => ({ ...prev, localFile: e.target.files?.[0]}));
    //     RASaveUpdateModal['FileName'] = e.target.files[0].name;
    //     mainRAModal['FileName'] = e.target.files[0].name;
    //     const file = e.target.files[0];
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = (event) => {
    //         const base64 = event.target.result.split("base64,")[1];
    //         setfile(base64);
    //         RASaveUpdateModal['RAPath'] = base64;
    //     };
    // }

    // const ViewPdf = (data) => {
    //     console.log("ViewPdfDownload")
    //     setPdfFile(null)
    //     setTxtFile(null)
    //     setImgFile(null)
    //     setIsLoading(true)
    //     ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
    //         "BucketPath": mainRAModal.RAPath
    //     }, 'Download').then((response) => {
    //         setIsLoading(false)
    //         console.log(response.type);
    //         if (response.type === 'application/txt') {
    //             const blob = response;
    //             const reader = new FileReader();
    //             reader.onload = () => {
    //                 const content = reader.result;
    //                 setTxtFile(content);
    //             };

    //             reader.readAsText(blob, 'utf-8');
    //         } else if (response.type === 'application/png') {
    //             const blob = response
    //             const objectURL = URL.createObjectURL(blob);
    //             setImgFile(objectURL)
    //         } else if (response.type === 'application/tiff') {

    //         }
    //         else {
    //             let file = new Blob([response]);
    //             const fileUrl = URL.createObjectURL(file);
    //             setPdfFile(fileUrl)
    //         }
    //         setModalActive(true)
    //     }).catch((error) => {
    //         setIsLoading(false)
    //         NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
    //     })
    // }

    // const removeFile = () => {
    //     setPdfFile(null);
    //     setTxtFile(null);
    //     setImgFile(null);

    //     if (fileInputRef.current) {
    //         fileInputRef.current.value = null;
    //     }
    //     setfile(null);
    //     RASaveUpdateModal['FileName'] = ''
    //     mainRAModal['FileName'] = ''
    //     RASaveUpdateModal['RAPath'] = ''

    //     setMainRAModal(mainRAModal);
    //     setRASaveUpdateModal(RASaveUpdateModal);
    // }
    useEffect(() => {
        setMainRAModal(RA_Modal)
        console.log("RiskAssessmentID", RiskAssessmentID)
        if (!isNull(RiskAssessmentID)) {
            setRAID(RiskAssessmentID)
            if (riskAssessmentModal.RiskAssessmentID) {
                setMainRAModal({ ...riskAssessmentModal, RiskAssessmentID: DropdownValueHandler(DropDowns.RAType, riskAssessmentModal.RiskAssessmentID) })
                setIs(true);
            }
        } else {
            setMainRAModal({
                ...RA_Modal, ...riskAssessmentModal,
                ...(riskAssessmentModal.RiskAssessmentID ? { RiskAssessmentID: DropdownValueHandler(DropDowns.RAType, riskAssessmentModal.RiskAssessmentID) } : {})
            })
            setIs(true);
        }
    }, [RiskAssessmentID])
    const handleCancelRA = () => {
        setRAID('0');
        setMainRAModal(RA_Modal);
        setRASaveUpdateModal({});
        // removeFile();
        // setfile(null)
        // onCancel();
        onClose();
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainRAModal };
        if (type === 'client' && !isNull(selectedData)) {
            console.log(selectedData, name, type);
                modal[name] = selectedData.display
                RASaveUpdateModal[name] = selectedData.value;
            // if (name === 'RiskAssessmentID') {
            //     modal[name] = selectedData.display
            //     RASaveUpdateModal[name] = selectedData.code + "";
            //     RASaveUpdateModal['RiskAssessmentID'] = selectedData.value + "";
            // }
            // else if (name === 'BillingRAStatus') {
            //     modal[name] = selectedData.display
            //     RASaveUpdateModal[name] = selectedData.value;
            // }
        }
        else {
            modal[name] = ''
            RASaveUpdateModal[name] = ''
        }
        setMainRAModal(modal)
        return selectedData
    }

    const AddRA = () => {
        return (
            <p className="heading">Add Risk Assessment</p>
        )
    }

    return (
        <Modal show={isOpenRiskAssessment} onHide={isOpenRiskAssessment} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 encounter_add_document">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                <ModalHeader HeaderName={AddRA} DeletePopup={''} isClosed={onClose} />
                <div className="d-flex flex-column gap-12">
                  <div className="input mb-0">
                    <label className="">Area of Risk<span className='req'>*</span></label>
                      <div className={RAValidationModal.AreaOfRiskVal ? 'form-group input error ar_palceholder' : 'form-group input  ar_palceholder'}>
                      <SuperSearchList
                        type="client"
                        id='AreaOfRisk'
                        name='AreaOfRisk'
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        searchValue={mainRAModal?.AreaOfRisk}
                        data={dropDownData?.AreaOfRisk?.length > 0 ? dropDownData?.AreaOfRisk : []}
                        onChange={handleRAChange}
                        getSelectedData={handleSelectedData}
                        is={is}
                        inputError={RAValidationModal.AreaOfRiskVal}
                      />
                      {RAValidationModal.AreaOfRiskVal}
                    </div>
                  </div>
                  <div className="input mb-0">
                    <label className="">Risk Level</label>
                    <div className='input mb-0  ar_palceholder'>
                      <SuperSearchList
                        type="client"
                        id='RiskLevel'
                        name='RiskLevel'
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        searchValue={mainRAModal?.RiskLevel}
                        data={dropDownData?.RiskLevel?.length > 0 ? dropDownData?.RiskLevel : []}
                        onChange={handleRAChange}
                        getSelectedData={handleSelectedData}
                      />
                    </div>
                  </div>
                  <div className="input mb-0">
                    <label className="">Risk Factors</label>
                    <div className='input mb-0  ar_palceholder'>
                      <SuperSearchList
                        type="client"
                        id='RiskFactors'
                        name='RiskFactors'
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        searchValue={mainRAModal?.RiskFactors}
                        data={dropDownData?.RiskFactors?.length > 0 ? dropDownData?.RiskFactors : []}
                        onChange={handleRAChange}
                        getSelectedData={handleSelectedData}
                      />
                    </div>
                  </div>
                  <div className="input mb-0">
                    <label className="">Protective Factors</label>
                    <div className='input mb-0  ar_palceholder'>
                      <SuperSearchList
                        type="client"
                        id='ProtectiveFactors'
                        name='ProtectiveFactors'
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        searchValue={mainRAModal?.ProtectiveFactors}
                        data={dropDownData?.ProtectiveFactors?.length > 0 ? dropDownData?.ProtectiveFactors : []}
                        onChange={handleRAChange}
                        getSelectedData={handleSelectedData}
                      />
                    </div>
                  </div>

                  <div className="input mb-0">
                    <label htmlFor="RiskAssessmentDescription">Notes</label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="RiskAssessmentNotes"
                      name="RiskAssessmentNotes"
                      value={mainRAModal.RiskAssessmentNotes}
                      onChange={handleRAChange}
                      rows="3"
                    />
                  </div>
                    <div className='d-flex align-items-center gap-2'>
                        <p className='heading fs-11'>By: <span className='green-text'>{mainRAModal.UpdateDate || 'N/A'}</span></p>
                        <p className='text light-clrs'>|</p>
                        <p className='heading fs-11'>Date: <span className='green-text'>{mainRAModal.UpdatedBy || 'N/A'}</span></p>
                    </div>
                </div>
            </Modal.Body>
            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr ' onClick={handleCancelRA}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                    <button className='btn btn-outline  px-10 h-100 validate-color' onClick={() => handleSaveRA("Add Another")}>Save & Add Another</button>
                    <button className='btn btn-validate px-10 h-100' onClick={handleSaveRA}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewRiskAssessment